import React, { createRef, useEffect, useLayoutEffect, useRef } from 'react'
import css from '@styled-system/css'
import useClickOutside from '../../helpers/useClickOutside'
import { useSpring, animated } from '@react-spring/web'
import { Container, Icon, Text, IconButton } from '../UI'
import FullInstrument from './FullInstrument'

const PreviewInstrument = ({
  id,
  toggleInstrument,
  expanded,
  imageExpanded,
  expandPreview,
  ...rest
}) => {
  const onClose = React.useCallback(() => {
    toggleInstrument(false)
  }, [toggleInstrument])

  const backdropRef = useRef()
  useClickOutside(backdropRef, onClose, imageExpanded)
  // modal doesn't trap focus...
  useLayoutEffect(() => {
    const el = document
      .getElementById(`inst-expand-bg-portal-${id}`)
      ?.querySelector('button')

    if (!el) return

    setTimeout(() => el.focus(), 100)
  }, [id])

  return (
    <Container
      role={'dialog'}
      id="preview-modal"
      aria-modal="true"
      ref={backdropRef}
      css={css({
        'max-height': 'calc(100vh - 8em)',
        position: 'relative',
        maxWidth: '45vh', // this works surprislingly well
        transform: 'translateY(-50%)',
        top: '50%',
      })}
      borderRadius={2}
      p={{ _: 2, md: 0 }}
      // background="white"
    >
      <FullInstrument
        {...rest}
        imageExpanded={imageExpanded}
        toggleInstrument={onClose}
      />
    </Container>
  )
}
export default PreviewInstrument
